import { EntityFiltersApi } from '../api/models';
import { FilterValues } from './filter-values';

export class EntityFilters
{
    constructor (public entityId: string, public filters: FilterValues[])
    {
    }
}

export class DomainEntityFilters
{
    public static mapperFromApi (source: EntityFiltersApi): EntityFilters
    {
        return new EntityFilters(source.entityId, [...source.filters]);
    }

    public static getFilterValues (filterValues: FilterValues[], filter: string): string
    {
        const entry = filterValues.find((m: FilterValues) =>
            m.filterKey === filter
        );

        return entry !== undefined ? entry .rootValues .join(',') : '';
    }
}
